import { useEffect, useState } from "react";
import {
  recordingService,
  type CallRecording,
} from "@/features/call/services/recordingService";

export const useCallRecordings = (callId: string | null) => {
  const [recordings, setRecordings] = useState<CallRecording[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!callId) return;

    setLoading(true);
    setError(null);

    recordingService
      .getRecordings(callId)
      .then(setRecordings)
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, [callId]);

  return { recordings, loading, error };
};
